var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: `text-${_vm.textColour}`,
      style: { backgroundColor: _vm.backgroundColour },
    },
    [
      _c(
        "swiper",
        {
          ref: "swiper",
          staticClass: "swiper relative h-full",
          attrs: { options: _vm.swiperOptions },
        },
        [
          _c(
            "div",
            {
              staticClass: "md:absolute inset-x-0 bottom-0 z-20",
              class:
                _vm.entryType === "paint"
                  ? "pb-15 md:pb-ogs-large"
                  : "pb-ogs-large",
              attrs: { slot: "pagination" },
              slot: "pagination",
            },
            [
              _c("div", { staticClass: "grid grid-cols-2" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-span-2 md:col-span-1 flex md:justify-center px-ogs",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "w-full",
                        class:
                          _vm.entryType === "paint"
                            ? "md:max-w-md lg:max-w-lg"
                            : "md:max-w-sm",
                      },
                      [_c("div", { staticClass: "swiper-pagination" })]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.testimonials, function (item, index) {
            return _c(
              "swiper-slide",
              { key: index, style: { height: "auto !important" } },
              [
                _c("div", { staticClass: "h-full grid grid-cols-2" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row-start-2 md:row-start-auto col-span-2 md:col-span-1 px-ogs",
                      class:
                        _vm.entryType === "paint"
                          ? "pt-15 pb-ogs-large"
                          : "py-ogs-large",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "h-full flex md:items-center md:justify-center md:pb-ogs-large",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "w-full",
                              class:
                                _vm.entryType === "paint"
                                  ? "md:max-w-md lg:max-w-lg"
                                  : "md:max-w-sm",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex space-x-2 mb-4 lg:mb-8" },
                                _vm._l(Number(item.rating), function (star) {
                                  return _c(
                                    "svg",
                                    {
                                      key: star,
                                      staticClass: "w-4 h-4 fill-current",
                                      class:
                                        _vm.entryType === "paint"
                                          ? "text-black"
                                          : "text-pink",
                                      attrs: { viewBox: "0 0 16 15" },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M8 0L9.79611 5.52786H15.6085L10.9062 8.94427L12.7023 14.4721L8 11.0557L3.29772 14.4721L5.09383 8.94427L0.391548 5.52786H6.20389L8 0Z",
                                        },
                                      }),
                                    ]
                                  )
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-lg lg:text-xl leading-relaxed lg:leading-snug mb-3",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.quote) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "text-xs lg:text-base",
                                domProps: { innerHTML: _vm._s(item.body) },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "row-start-1 md:row-start-auto col-span-2 md:col-span-1 bg-grey",
                    },
                    [
                      _c("div", { staticClass: "pt-11/12 h-full relative" }, [
                        _c("picture", [
                          _c("source", {
                            attrs: {
                              type: "image/webp",
                              srcset: `${item.image[0].webpSm} 570w,
                  ${item.image[0].webpLg} 1440w`,
                              sizes: "(max-width: 570px) 570px, 1440px",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass:
                              "absolute top-0 left-0 w-full h-full object-cover",
                            attrs: {
                              srcset: `${item.image[0].defaultSm} 570w,
                  ${item.image[0].defaultLg} 1440w`,
                              sizes: "(max-width: 570px) 570px, 1440px",
                              src: item.image[0].defaultLg,
                              alt: item.image[0].title,
                              loading: "lazy",
                              decoding: "async",
                              width: "1440",
                              height: "1440",
                            },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }